import React from 'react';
import { FiMail } from 'react-icons/fi';
import OpsBadge from './OpsBadge';
import { getWorkflowConfig } from '../utils/workflowLabels';

const yesNo = (value) => {
    if (value === true) return 'Oui';
    if (value === false) return 'Non';
    return '—';
};

const statusLines = (status) => [
    ['Forecast importé', yesNo(status.forecast_exists)],
    ['Forecast checké', yesNo(status.forecast_checked)],
    ['Déclenché', yesNo(status.is_triggered_forecast)],
    ['Sinistre', yesNo(status.claim_exists)],
    ['E-mail envoyé', yesNo(status.forecast_email_sent)],
    ['Observation checkée', yesNo(status.observation_checked)],
];

const pendingDetail = (status) => (
    status.forecast_exists ? 'Forecast importé, check à faire' : 'Forecast non importé'
);

const WorkflowBadge = ({ label, context, status, overdue = false }) => {
    const config = getWorkflowConfig(label, context);
    const icon = label === 'forecast_checked_triggered_email_pending' ? FiMail : undefined;
    const tone = overdue && config.overdueTone ? config.overdueTone : config.tone;

    if (context !== 'forecast' || !status) {
        return (
            <OpsBadge
                tone={tone}
                icon={icon}
                label={config.text}
                tooltip={config.description || undefined}
                className="ops-workflow-badge"
            />
        );
    }

    const headline = label === 'forecast_pending' ? pendingDetail(status) : config.description;
    const lines = statusLines(status);
    const tooltipText = [
        headline,
        overdue ? 'Heure de check dépassée' : null,
        ...lines.map(([name, value]) => `${name} : ${value}`),
    ].filter(Boolean).join(' · ');

    return (
        <OpsBadge
            tone={tone}
            icon={icon}
            label={config.text}
            tooltipText={tooltipText}
            tooltip={(
                <div className="ops-status-tooltip">
                    {headline && <div className="ops-status-tooltip__title">{headline}</div>}
                    {overdue && <div className="ops-status-tooltip__warn">Heure de check dépassée</div>}
                    <dl className="ops-status-tooltip__list">
                        {lines.map(([name, value]) => (
                            <React.Fragment key={name}>
                                <dt>{name}</dt>
                                <dd>{value}</dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </div>
            )}
            className="ops-workflow-badge"
        />
    );
};

export default WorkflowBadge;
